import _ from 'lodash';
import moment from 'moment';

import {
  capitalizeSentenceWords,
  sanitizeSpecialChars,
  trimSpaces,
  sanitizeHyphenatedLastName,
} from '../../helpers/utils';
import { offeringCategory } from '../../helpers/mappings';

export const modelFields = [
  {
    fields: [
      {
        field: 'First Name',
        order: 0,
        isSelected: true,
      },
      {
        field: 'Middle Name',
        order: 1,
        isSelected: true,
      },
      {
        field: 'Last Name',
        order: 2,
        isSelected: true,
      },
    ],
    order: 0,
  },
  {
    fields: [
      {
        field: 'Address Line 1',
        order: 0,
        isSelected: true,
      },
      {
        field: 'Address Line 2',
        order: 1,
        isSelected: true,
      },
    ],
    order: 1,
  },
  {
    fields: [
      {
        field: 'State Code',
        order: 0,
        isSelected: true,
      },
    ],
    order: 2,
  },
  {
    fields: [
      {
        field: 'City',
        order: 0,
        isSelected: true,
      },
    ],
    order: 3,
  },
  {
    fields: [
      {
        field: 'Postal Code',
        order: 0,
        isSelected: true,
      },
    ],
    order: 4,
  },
  {
    fields: [
      {
        field: 'Tax ID',
        order: 0,
        isSelected: true,
      },
    ],
    order: 5,
  },
  {
    fields: [
      {
        field: 'Number of Shares',
        order: 0,
        isSelected: true,
      },
    ],
    order: 6,
  },
  {
    fields: [
      {
        field: 'Requested Total Currency Amount',
        order: 0,
        isSelected: true,
      },
    ],
    order: 7,
  },
  {
    fields: [
      {
        field: 'Offer Price per Share',
        order: 0,
        isSelected: true,
      },
    ],
    order: 8,
  },
  {
    fields: [
      {
        field: 'Created At',
        order: 0,
        isSelected: true,
      },
    ],
    order: 9,
  },
  {
    fields: [
      {
        field: 'Email',
        order: 0,
        isSelected: true,
      },
    ],
    order: 10,
  },
  {
    fields: [
      {
        field: 'Offer Name',
        order: 0,
        isSelected: false,
      },
    ],
    order: 11,
  },
  {
    fields: [
      {
        field: 'Account Number',
        order: 0,
        isSelected: false,
      },
    ],
    order: 12,
  },
  {
    fields: [
      {
        field: 'Deliver Securities Mode',
        order: 0,
        isSelected: false,
      },
    ],
    order: 13,
  },
  {
    fields: [
      {
        field: 'Accreditation',
        order: 0,
        isSelected: false,
      },
    ],
    order: 14,
  },
  {
    fields: [
      {
        field: 'Order Status',
        order: 0,
        isSelected: false,
      },
    ],
    order: 15,
  },
  {
    fields: [
      {
        field: 'Is Order Status Change Email Sent',
        order: 0,
        isSelected: false,
      },
    ],
    order: 16,
  },
  {
    fields: [
      {
        field: 'Offer Type',
        order: 0,
        isSelected: false,
      },
    ],
    order: 17,
  },
  {
    fields: [
      {
        field: 'Offer Status',
        order: 0,
        isSelected: false,
      },
    ],
    order: 18,
  },
  {
    fields: [
      {
        field: 'Offer Industry',
        order: 0,
        isSelected: false,
      },
    ],
    order: 19,
  },
  {
    fields: [
      {
        field: 'Offer Sector',
        order: 0,
        isSelected: false,
      },
    ],
    order: 20,
  },
  {
    fields: [
      {
        field: 'Offer Category',
        order: 0,
        isSelected: false,
      },
    ],
    order: 21,
  },
  {
    fields: [
      {
        field: 'Security Type',
        order: 0,
        isSelected: false,
      },
    ],
    order: 22,
  },
];

const accreditationStatus = {
  NOT_ACCREDITED: 'Not accredited',
  ACCREDITED: 'Accredited',
};

export const transformDataForExportFn = (data, chosenFields) => {
  const mapped = data.map(element => [
    { key: 'First Name', value: trimSpaces(capitalizeSentenceWords(sanitizeSpecialChars(element.user.firstName, /[.,-]/g))) },
    { key: 'Middle Name', value: trimSpaces(capitalizeSentenceWords(sanitizeSpecialChars(element.user.middleName, /[.,-]/g))) },
    { key: 'Last Name', value: sanitizeHyphenatedLastName(trimSpaces(capitalizeSentenceWords(sanitizeSpecialChars(element.user.lastName, /[.,]/g)))) },
    { key: 'Address Line 1', value: trimSpaces(capitalizeSentenceWords(sanitizeSpecialChars(element.user.primaryAddress.line1, /[.,]/g))) },
    { key: 'Address Line 2', value: trimSpaces(capitalizeSentenceWords(sanitizeSpecialChars(element.user.primaryAddress.line2, /[.,]/g))) },
    { key: 'City', value: trimSpaces(capitalizeSentenceWords(element.user.primaryAddress.city)) },
    { key: 'State Code', value: element.user.primaryAddress.state },
    { key: 'Postal Code', value: element.user.primaryAddress.zipcode },
    { key: 'Tax ID', value: element.user.tid },
    { key: 'Number of Shares', value: parseFloat(element.requestedTotalCurrencyAmt / element.offer.pricePerShare).toFixed(3) },
    { key: 'Requested Total Currency Amount', value: element.requestedTotalCurrencyAmt.toLocaleString('en-US', { style: 'currency', currency: 'USD' }) },
    { key: 'Offer Price per Share', value: element.offer.pricePerShare.toLocaleString('en-US', { style: 'currency', currency: 'USD' }) },
    { key: 'Created At', value: moment(new Date(element.createdAt)).format('DD/MM/YYYY') },
    { key: 'Email', value: element.user.email },
    { key: 'Offer Name', value: element.offer.name },
    { key: 'Account Number', value: element.accountNumber },
    { key: 'Deliver Securities Mode', value: element.deliverSecuritiesMode },
    { key: 'Accreditation', value: accreditationStatus[element.accreditation] },
    { key: 'Order Status', value: element.endStatus ? element.endStatus.toUpperCase() : 'PENDING' },
    { key: 'Is Order Status Change Email Sent', value: element.isEndStatusChangeEmailSent ? 'YES' : 'NO' },
    { key: 'Offer Type', value: element.offer.offerType },
    { key: 'Offer Status', value: element.offer.status },
    { key: 'Offer Industry', value: element.offer.industry },
    { key: 'Offer Sector', value: element.offer.sector },
    { key: 'Offer Category', value: _.values(offeringCategory).find(item => item.value === element.offer.category).label },
    { key: 'Security Type', value: element.offer.securityType },
  ].filter(({ key }) => chosenFields.includes(key)).reduce((obj, { key, value }) => ({ ...obj, [key]: value }), {}));
  return mapped;
};



// WEBPACK FOOTER //
// ./src/components/ExternalOfferOrder/constants.js